import { useMemo } from 'react';
import { LayerGroup, LayersControl } from 'react-leaflet';
import { isPositionModelWithLatLng, PositionModel } from '@customer/store/apis/assetsApi';
import { useTranslation } from 'react-i18next';
import ObjectEventMarker, {
  ObjectEventMarkerProps,
  ObjectEventType,
} from '../markers/object-event-marker/ObjectEventMarker';
import { getRotationProps } from '../markers/utils';

interface StartEndObjectsProps {
  startPos: PositionModel;
  endPos?: PositionModel | null;
}

export function StartEndObjects({ startPos, endPos }: StartEndObjectsProps) {
  const { t } = useTranslation();

  const layerData = useMemo<ObjectEventMarkerProps[]>(() => {
    const layerData: ObjectEventMarkerProps[] = [];

    if (isPositionModelWithLatLng(startPos)) {
      layerData.push({
        ...getRotationProps(startPos),
        eventType: ObjectEventType.Start,
        time: startPos.ts,
      });
    }

    if (isPositionModelWithLatLng(endPos)) {
      layerData.push({
        ...getRotationProps(endPos),
        eventType: ObjectEventType.End,
        time: endPos.ts,
      });
    }

    return layerData;
  }, [startPos, endPos]);

  return (
    <>
      {layerData.map((objectMarkerProps: ObjectEventMarkerProps, idx: number) => {
        return (
          <LayersControl.Overlay
            key={idx}
            name={t(`MapObjectEvents.${objectMarkerProps.eventType}`)}
            checked={true}
          >
            <LayerGroup>
              <ObjectEventMarker {...objectMarkerProps} />
            </LayerGroup>
          </LayersControl.Overlay>
        );
      })}
    </>
  );
}

export default StartEndObjects;
